import { render } from "./newsdetail.vue?vue&type=template&id=878936bc&scoped=true"
import script from "./newsdetail.vue?vue&type=script&lang=js"
export * from "./newsdetail.vue?vue&type=script&lang=js"

import "./newsdetail.vue?vue&type=style&index=0&id=878936bc&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878936bc"]])

export default __exports__